module.exports = __webpack_public_path__ + "img/why.0e37df23.webp";